import React from 'react';
import { Table } from 'semantic-ui-react';
import { userUrl } from '@/constants/urls';
import {
  columnNameLink,
  columnDescription,
  columnCreatedBy,
  columnCreatedByLink,
  columnTools,
  columnCreatedOn,
  hasColumn,
} from '@/constants/fields';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import NameCell from '@/components/table/NameCell';
import NotificationTools from './NotificationTools';

const NotificationRow = ({
  category,
  code,
  event,
  columns = [
    columnNameLink,
    columnDescription,
    columnCreatedBy,
    columnTools,
    columnCreatedOn,
  ],
  notification,
  showNotification,
  upward,
}) => (
  <NameDescriptionRow
    asHref
    className="aridhia-notification-row"
    columns={columns}
    description={notification.description}
    entity="notification"
    href="#"
    name={notification.name}
    onClick={() => showNotification({ event, notificationCode: notification.code })}
  >
    {hasColumn(columns, [columnCreatedBy, columnCreatedByLink]) && (
      <NameCell
        name={notification.author.name}
        link={hasColumn(columns, [columnCreatedByLink]) ? userUrl(notification.author) : undefined}
      />
    )}
    {hasColumn(columns, columnCreatedOn) && (<Table.Cell content={notification.createdOn} />)}
    {hasColumn(columns, columnTools) && (
      <Table.Cell collapsing>
        <NotificationTools
          category={category}
          code={code}
          event={event}
          notificationCode={notification.code}
          upward={upward}
        />
      </Table.Cell>
    )}
  </NameDescriptionRow>
);

export default NotificationRow;
